import { render, staticRenderFns } from "./DashboardTable.vue?vue&type=template&id=59e4ef7a&scoped=true"
import script from "./DashboardTable.vue?vue&type=script&lang=js"
export * from "./DashboardTable.vue?vue&type=script&lang=js"
import style0 from "./DashboardTable.vue?vue&type=style&index=0&id=59e4ef7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e4ef7a",
  null
  
)

export default component.exports